var _path, _path2, _rect, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 2.66667V2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2H4V2.66667C4 3.40305 4.59695 4 5.33333 4C6.06971 4 6.66667 3.40305 6.66667 2.66667V2H9.33333V2.66667C9.33333 3.40305 9.93029 4 10.6667 4C11.403 4 12 3.40305 12 2.66667Z",
    fill: "#8D8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 7.33317C3.33325 6.96498 3.63173 6.6665 3.99992 6.6665H5.33325C5.70144 6.6665 5.99992 6.96498 5.99992 7.33317V8.6665C5.99992 9.03469 5.70144 9.33317 5.33325 9.33317H3.99992C3.63173 9.33317 3.33325 9.03469 3.33325 8.6665V7.33317Z",
    fill: "#8D8D8D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 3.33325,
    y: 4.6665,
    width: 9.33333,
    height: 1.33333,
    rx: 0.666667,
    fill: "#8D8D8D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 10.6665C3.33325 10.2983 3.63173 9.99984 3.99992 9.99984H5.33325C5.70144 9.99984 5.99992 10.2983 5.99992 10.6665V11.9998C5.99992 12.368 5.70144 12.6665 5.33325 12.6665H3.99992C3.63173 12.6665 3.33325 12.368 3.33325 11.9998V10.6665Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 7.33317C6.66659 6.96498 6.96506 6.6665 7.33325 6.6665H8.66659C9.03478 6.6665 9.33325 6.96498 9.33325 7.33317V8.6665C9.33325 9.03469 9.03478 9.33317 8.66659 9.33317H7.33325C6.96506 9.33317 6.66659 9.03469 6.66659 8.6665V7.33317Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 10.6665C6.66659 10.2983 6.96506 9.99984 7.33325 9.99984H8.66659C9.03478 9.99984 9.33325 10.2983 9.33325 10.6665V11.9998C9.33325 12.368 9.03478 12.6665 8.66659 12.6665H7.33325C6.96506 12.6665 6.66659 12.368 6.66659 11.9998V10.6665Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 7.33317C9.99992 6.96498 10.2984 6.6665 10.6666 6.6665H11.9999C12.3681 6.6665 12.6666 6.96498 12.6666 7.33317V8.6665C12.6666 9.03469 12.3681 9.33317 11.9999 9.33317H10.6666C10.2984 9.33317 9.99992 9.03469 9.99992 8.6665V7.33317Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 10.6665C9.99992 10.2983 10.2984 9.99984 10.6666 9.99984H11.9999C12.3681 9.99984 12.6666 10.2983 12.6666 10.6665V11.9998C12.6666 12.368 12.3681 12.6665 11.9999 12.6665H10.6666C10.2984 12.6665 9.99992 12.368 9.99992 11.9998V10.6665Z",
    fill: "#8D8D8D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 2.00016C4.66675 1.63197 4.96522 1.3335 5.33341 1.3335C5.7016 1.3335 6.00008 1.63197 6.00008 2.00016V2.66683C6.00008 3.03502 5.7016 3.3335 5.33341 3.3335C4.96522 3.3335 4.66675 3.03502 4.66675 2.66683V2.00016Z",
    fill: "#8D8D8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.00016C10 1.63197 10.2985 1.3335 10.6667 1.3335C11.0349 1.3335 11.3333 1.63197 11.3333 2.00016V2.66683C11.3333 3.03502 11.0349 3.3335 10.6667 3.3335C10.2985 3.3335 10 3.03502 10 2.66683V2.00016Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7581a0a39e37dab6aae84e5840e6e855.svg";
export { ForwardRef as ReactComponent };